import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyFinancials } from '../propertyEndpoints'

export function usePropertyFinancialsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.financials(toValue(id)),
    queryFn: () => getPropertyFinancials(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
